namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_menu, {
		width: '14rem', flex: { grow: 0, shrink: 0, basis: '14rem' },
		Version: { color: $mol_theme.shade },
		Drafts_count: { color: $mol_theme.shade },
		Head: { flexWrap: 'nowrap' },
		Title: { minWidth: 0 },
		Name: { display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0, flex: { shrink: 1 } },
		Tools: { flexWrap: 'nowrap', flex: { shrink: 0 } },
	})
}
